import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { StatusViewPopoverPage } from "./status-view-popover";

@NgModule({
  declarations: [StatusViewPopoverPage],
  imports: [IonicPageModule.forChild(StatusViewPopoverPage)],
})
export class StatusViewPopoverPageModule {}



// WEBPACK FOOTER //
// ./src/navigation/components/status-view-popover/status-view-popover.module.ts